<template>
    <div class="create-courses">
        <div class="page-title">新增课程</div>
        <div class="container">
            <div class="head">
                <div class="label">基础内容</div>
                <div class="line"></div>
            </div>
            <div class="content-box">
                
                <div class="row">
                    <div class="label">
                        <span class="red">*</span>
                        <span>课程标题</span>
                    </div>
                    <div class="input-box">
                        <input v-model="params.title" type="text" placeholder="请输入不超过20字的标题" maxlength="20">
                        <div class="num">{{ params.title.length }}/20</div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="label">
                        <span class="white">占</span>
                        <span class="red">*</span>
                        <span>副标题</span>
                    </div>
                    <div class="input-box">
                        <input v-model="params.sub_title" type="text" placeholder="请输入不超过30字的副标题"
                               maxlength="30">
                        <div class="num">{{ params.sub_title.length }}/30</div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="label">
                        <span class="red">*</span>
                        <span>课程封面</span>
                    </div>
                    <div>
                        <div class="content-img">
                            <upload-image v-model="params.thumb"/>
                        </div>
                        <div class="thumb-tips">
                            图片格式必须为:png,jpeg,jpg;不可大于1M；<br>
                            建议使用png格式图片，以保持最佳效果;建议图片尺寸为600px*600px；
                        </div>
                        <div class="at-item-warning">
                            建议上传图片上没有任何文字，因为手机端标题及描述将会自动置于该图片上方
                        </div>
                    </div>
                
                </div>
                
                <div class="form-row">
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">课程时间</div>
                            <div class="tips">（选填）</div>
                        </div>
                        <div class="form">
                            <a-date-picker v-model="params.start" :show-time="{ format: 'HH:mm' }"
                                           class="date-picker class-time-picker" format="YYYY-MM-DD HH:mm"
                                           placeholder="选择时间"/>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">排序序号</div>
                        </div>
                        <div class="form">
                            <div class="input">
                                <input v-model="params.sort" type="text">
                            </div>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">授课方式</div>
                        </div>
                        <div class="form">
                            <a-select v-model="params.type" class="at-select">
                                <a-select-option value="online">线上授课</a-select-option>
                                <a-select-option value="offline">线下授课</a-select-option>
                                <a-select-option value="video" v-if="$app.modules.course_video">在线视频
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                </div>
                
                <div class="form-row">
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">课程价格</div>
                            <div class="tips">（选填）</div>
                        </div>
                        <div class="form">
                            <div class="input">
                                <!-- <input v-model="params.price" type="text"> -->
                                <at-input :unit="$app.payment.symbol" v-model="params.price" width="100%"></at-input>
                            </div>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">报名开启<br>支付</div>
                        </div>
                        <div class="form">
                            <a-select v-model="params.pay_enabled" @change="params.pay_amount = '0.00'"
                                      class="at-select">
                                <a-select-option :value="1">开启</a-select-option>
                                <a-select-option :value="0">关闭</a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">支付金额</div>
                        </div>
                        <div class="form">
                            <div class="input">
                                <at-input :unit="$app.payment.symbol" v-model="params.pay_amount"
                                          :disabled="!params.pay_enabled" width="100%"></at-input>
                                <!-- <input v-model="params.pay_amount" :disabled="!params.pay_enabled" type="number"> -->
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="form-row">
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">地点</div>
                            <div class="tips">（选填）</div>
                        </div>
                        <div class="form">
                            <div class="input">
                                <input v-model="params.address" type="text">
                            </div>
                        </div>
                    </div>
                    <template v-if="shareEnabled">
                        <div class="form-item">
                            <div class="form-label">
                                <div class="label">开启分销</div>
                            </div>
                            <div class="form">
                                <a-select v-model="params.share_enabled" class="at-select">
                                    <a-select-option :value="1">开启</a-select-option>
                                    <a-select-option :value="0">关闭</a-select-option>
                                </a-select>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">
                                <div class="label">分销比例</div>
                            </div>
                            <div class="form">
                                <div class="input">
                                    <input v-model="params.share_scale" :disabled="!params.share_enabled" type="text">
                                    <div class="scale-unit">%</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    
                    <div v-else>
                        <!-- 如需开通分销功能，请联系客服进行机构认证！-->
                    </div>
                </div>
                
                <div class="row">
                    <div class="label">
                        <span class="red">*</span>
                        <span>课程详情</span>
                    </div>
                    <div class="input-box">
                        <a-textarea :rows="5" v-model="params.summary"
                                    placeholder="请输入课程内容相关说明"></a-textarea>
                    </div>
                </div>
                
                <div class="row">
                    <div class="label" style="width: 62px"></div>
                    <div>
                        <div class="content-img">
                            <upload-image v-model="params.content_images" multiple/>
                        </div>
                        <div class="thumb-tips">
                            图片格式必须为:png,bmp,jpeg,jpg;不可大于4M;<br>
                            建议使用png格式图片，以保持最佳效果;建议图片宽度为980px
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="label mt-0">报名后 <br>微信客服</div>
                    <service-row :is-system.sync="params.customer_service_system"
                                 :customer-service-img.sync="params.customer_service_img"></service-row>
                </div>
            
            </div>
        </div>
        <div class="container" v-if="params.type == 'video' && params.id">
            <div class="head">
                <div class="label head-label">
                    <div>课程章节</div>
                    <div class="play-label">
                        <span class="attr">顺序观看</span>
                        <switch-button v-model="isOpenPlaySwitch" @change="playModeChange"></switch-button>
                    </div>
                </div>
                <div class="line"></div>
            </div>
            <a-alert v-if="isExpired" type="warning" show-icon class="expire-warning">
                <template slot="message">
                    视频套餐已经到期，无法添加新的章节或小节，请联系管理员续费后再使用相关功能
                </template>
            </a-alert>
            <div class="catalog-box">
                <catalog ref="catalogRef" :course_id="params.id" :list="list" @addSubitem="addSubItem"
                         @editSubitem="editSubItem"></catalog>
                <div class="add-parent cursor" @click="addParentHandle">
                    <div>点击继续添加章节</div>
                    <img src="/assets/icons/new-question-finger.png">
                </div>
            </div>
        </div>
        <div class="container">
            <div class="head">
                <div class="label">课程营销</div>
                <div class="line"></div>
            </div>
            <div class="content-box">
                <div class="form-row">
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">首次购买<br>优惠价格</div>
                        </div>
                        <div class="form">
                            <div class="input">
                                <input v-model="params.first_buy_amount" type="text">
                            </div>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">首次购买优惠限时</div>
                            <div class="tips">(分钟)</div>
                        </div>
                        <div class="form">
                            <div class="input">
                                <input v-model="params.first_buy_time" type="text">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="head">
                <div class="label">购买后功能</div>
                <div class="line"></div>
            </div>
            <div class="content-box">
                <div class="form-row">
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">赠送<br>衣橱会员</div>
                        </div>
                        <div class="form">
                            <a-select v-model="params.give_wd_vip" class="at-select">
                                <a-select-option :value="1">赠送</a-select-option>
                                <a-select-option :value="0">不赠送</a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">会员<br>有效期限</div>
                        </div>
                        <div class="form">
                            <a-select v-model="params.give_member_level_days" class="at-select"
                                      :disabled="params.give_member_level === 0">
                                <template v-for="(md) in memberLevelDays">
                                    <a-select-option :value="md.day" :key="md.day" v-if="true">
                                        <span>{{ md.name }}</span>
                                    </a-select-option>
                                </template>
                            </a-select>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">等级变更</div>
                        </div>
                        <div class="form">
                            <a-select v-model="params.give_member_level" class="at-select">
                                <a-select-option :value="0">不变更</a-select-option>
                                <template v-for="(level, key) in memberLevels">
                                    <a-select-option :value="level.id" :key="key" v-if="true">
                                        <span>{{ level.name }}</span>
                                    </a-select-option>
                                </template>
                            </a-select>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">给予权限</div>
                        </div>
                        <div class="form">
                            <a-select v-model="params.give_permissions" mode="tags" class="at-select"
                                      placeholder="不给予权限">
                                <template v-for="(name, key) in memberPermissions">
                                    <a-select-option :value="key" :key="key" v-if="true">{{ name }}</a-select-option>
                                </template>
                            </a-select>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-item">
                        <div class="form-label">
                            <div class="label">赠送 <br/> 预约项目</div>
                        </div>
                        <div class="form" style="width: 500px;">
                            <course-appointment-branch-picker v-model="params.give_appointments"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="btn-box">
            <div class="btn cursor" @click="submit">{{ params.id ? '保存' : '创建' }}</div>
            <template v-if="params.id">
                <div class="btn btn-white cursor">
                    <span v-if="params.status == 0" @click="stock(1)">上架</span>
                    <span v-else @click="stock(0)">下架</span>
                </div>
                <div class="btn btn-white cursor" @click="deleteItem">删除</div>
            </template>
        </div>
        
        <video-list v-if="showList" @confirm="videoConfirm" @close="showList = false"></video-list>
        
        <a-modal v-model="showVideoModal" :footer="null" width="800px" destroyOnClose>
            <template v-if="videoInfo">
                
                <div slot="title">{{ videoInfo.name }}</div>
                
                <video style="width: 100%" :src="videoInfo.url" autoplay controls></video>
            
            </template>
        </a-modal>
        
        <!-- 修改/添加小节 -->
        <a-modal v-model="showEditSubItem" :footer="null" centered :maskClosable="false" width="850px">
            <div slot="title">小节内容</div>
            <div class="add-modal-box">
                <div class="add-form-row">
                    <div class="child-label">
                        <div class="text">&nbsp;&nbsp;节标题&nbsp;&nbsp;</div>
                    </div>
                    <div class="input-container">
                        <a-input v-model="editItem.title" class="at-input"
                                 placeholder="可输入小节标题、例：第一节.../第二节.../第三节..."/>
                    </div>
                </div>
                <div class="add-form-row">
                    <div class="label empty-label"></div>
                    <div class="input-container" style="padding: 16px;">
                        <a-textarea class="textarea" v-model="editItem.summary" placeholder="可输入小节内容说明"
                                    autoSize></a-textarea>
                    </div>
                </div>
                <div class="add-form-row">
                    <div class="child-label">
                        <div class="text">课程作业</div>
                        <div class="tips">（选填）</div>
                    </div>
                    <div class="video-container">
                        <div class="video" v-if="editItem.file" @click="playVideo(editItem.file)">
                            <img class="thumb" :src="editItem.file.thumb">
                            <div class="video-play-btn"></div>
                            <div class="mask">
                                <div class="icon" @click.stop="delVideo()">
                                    <img src="/assets/images/video/del-select.png">
                                </div>
                                <div class="size">{{ videoSize(editItem.file) }}</div>
                                <div class="name">{{ editItem.file.name }}</div>
                            </div>
                        </div>
                        <div class="no-video" v-else>
                            暂无
                        </div>
                    </div>
                </div>
                
                <div class="add-form-row">
                    <div class="label empty-label"></div>
                    <div class="video-btn-row">
                        <div class="video-btn cursor" @click="openList()">
                            <img src="/assets/icons/qa-add.png">
                            <span>选择视频</span>
                        </div>
                        <div class="video-btn cursor" @click="uploadVideo()">
                            <img src="/assets/images/video/btn-icon2.png">
                            <span>上传视频</span>
                        </div>
                    </div>
                </div>
                
                <div class="add-form-row home-work-container">
                    <div class="child-label">
                        <div class="text">课程作业</div>
                        <div class="tips">（选填）</div>
                    </div>
                    <div class="home-work-list">
                        <div class="home-work" v-for="(home, idx) in editItem.homeworks" :key="'homework-' + idx">
                            <input v-model="home.title" type="text">
                            <div class="del-box" @click="delHomework(idx)">
                                <img src="/assets/images/video/task-icon3.png">
                            </div>
                        </div>
                        <div class="home-work-btn-box">
                            <div class="add" @click="addHomework">
                                <img src="/assets/images/video/task-icon2.png">
                                <span>添加作业</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <video-add-qa v-model="editItem.qa_ids"></video-add-qa>
                
                <div class="save-sub-btn btn" @click="saveSubItem">保存</div>
            </div>
        </a-modal>
        
        <upload-video v-if="showUpload" @uploadSuccess="uploadSuccess" @uploadClose="uploadClose"></upload-video>
        <upload-file v-if="showUploadFile" @uploadSuccess="uploadFileSuccess"
                     @uploadClose="uploadFileClose"></upload-file>
    
    </div>
</template>

<script>
import api from '@/repo/api';
import moment from "moment/moment";
import VideoList from './com/VideoList.vue';
import UploadImage from "@/components/UploadImage.vue";
import AtInput from "@/components/AtInput.vue";
import UploadVideo from "@/components/UploadVideo.vue";
import UploadFile from '@/components/UploadFile.vue';
import ServiceRow from "@/views/AST/Serve/com/ServiceRow.vue";
import CourseAppointmentBranchPicker from "@/views/AST/Serve/com/CourseAppointmentBranchPicker.vue";
import Catalog from "@/views/AST/Serve/com/Catalog.vue";
import VideoAddQa from "@/views/AST/Serve/com/VideoAddQa.vue";
import SwitchButton from "@/components/SwitchButton.vue";

export default {
    components: {
        SwitchButton,
        VideoAddQa,
        CourseAppointmentBranchPicker,
        ServiceRow,
        AtInput,
        VideoList,
        UploadImage,
        UploadVideo,
        UploadFile,
        Catalog
    },
    data() {
        return {
            routeMatch: "/ast/serve/cla",
            showList: false,
            showUploadFile: false,
            memberLevelDays: [
                {name: "7天", day: 7},
                {name: "半个月 (15天)", day: 15},
                {name: "1个月 (30天)", day: 30},
                {name: "3个月 (90天)", day: 90},
                {name: "半年 (180天)", day: 180},
                {name: "1年 (365天)", day: 365},
                {name: "3年 (1095天)", day: 1095},
                {name: "长期", day: -1}
            ],
            params: {
                group: "courses",
                title: '',
                sub_title: '',
                thumb: '',
                start: '',
                sort: '',
                type: '',
                pay_enabled: 0,
                pay_amount: '0.00',
                price: '',
                share_enabled: 0,
                share_scale: '',
                address: '',
                summary: '',
                content_images: [],
                first_buy_amount: '',
                customer_service_system: 1,
                first_buy_time: '',
                give_wd_vip: '',
                give_member_level: 0,
                give_member_level_days: '',
                give_permissions: [],
                play_mode: "freedom",
            },
            videoInfo: null,
            showVideoModal: false,
            shareEnabled: 0,
            memberLevels: [],
            memberPermissions: {},
            nos: 'ABCDEFGHIJKLMNOPQRSTUVWXZY',
            engCode: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
            chCode: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'],
            list: [
                {
                    title: '',
                    children: [
                        {
                            title: '',
                            summary: '',
                            attachment_list: [],
                            homeworks: [],
                        }
                    ]
                }
            ],
            child: {},
            showUpload: false,
            showEditSubItem: false,
            editItemParent: {},
            editItem: {
                title: '',
                summary: '',
                attachment_list: [],
                homeworks: [
                    {title: ''}
                ],
                qa_ids: [],
            },
            isEdit: false,
            isOpenPlaySwitch: false,
            info: {},
        }
    },
    mounted() {
        let query = this.$route.query;
        
        this.shareEnabled = this.$app['course_share'];
        
        this.getInfo();
        
        if (query.id) {
            this.getDetail(query.id);
        }
        this.getPermissionsAndLevels();
    },
    computed: {
        isExpired() {
            if (!this.info.expired_at) return false;
            return moment(this.info.expired_at).isBefore(moment(), 'day');
        },
    },
    methods: {
        playModeChange(val) {
            this.params.play_mode = val ? "order" : "freedom";
        },
        getInfo() {
            api.get('/ast-space/info', res => {
                if (res.code == 0) {
                    this.info = {
                        expired_at: res.data.expired_at
                    };
                }
            })
        },
        sortChange(newList) {
            // newList是id的数组，根据newList的顺序重新排序this.list
            this.list = newList.map(id => {
                return this.list.find(item => item.id == id);
            })
        },
        deleteItem() {
            this.confirm('确定要删除？').then(() => {
                
                api.post('/course/delete', {id: this.params.id}, () => {
                    this.$router.replace({
                        path: '/ast/serve/cla'
                    })
                })
                
            })
        },
        playVideo(item) {
            this.videoInfo = item;
            this.showVideoModal = true;
        },
        confirm(title) {
            return new Promise((resolve) => {
                this.$confirm({
                    title: title,
                    content: '此操作不可逆。',
                    onOk() {
                        resolve()
                    },
                });
            })
        },
        stock(status) {
            
            let title = status ? "上架" : '下架';
            
            this.confirm('确定' + title).then(() => {
                
                api.post('/course/stock', {status, id: this.params.id}, () => {
                    
                    this.$router.replace({
                        path: '/ast/serve/cla'
                    })
                    
                })
                
            })
        },
        videoSize(item) {
            let size = Number(item.size) / 1024 / 1024;
            return size.toFixed(2) + 'MB';
        },
        delVideo() {
            this.$set(this.editItem, 'file', '');
        },
        openList() {
            this.showList = true;
        },
        uploadVideo() {
            if (this.isExpired) {
                this.$message.warning('视频套餐已经到期，无法上传视频，请联系管理员续费');
                return;
            }
            this.showUpload = true;
        },
        uploadClose() {
            this.showUpload = false;
        },
        uploadSuccess(video) {
            console.log(video);
            this.$loading.hide();
            this.showUpload = false;
            if (video.name.split('.').length > 1) {
                video.name = video.name.split('.')[0];
                this.updateInfo({name: video.name, id: video.id});
            }
            this.videoConfirm(video);
        },
        videoConfirm(item) {
            console.log(123, item);
            this.$set(this.editItem, 'file', item);
            this.$set(this.editItem, 'file_id', item.id);
            console.log(456, this.editItem);
            this.showList = false;
        },
        uploadFile(child) {
            this.child = child;
            this.showUploadFile = true;
        },
        uploadFileClose() {
            this.showUploadFile = false;
        },
        uploadFileSuccess(file) {
            console.log(file);
            this.$loading.hide();
            this.showUploadFile = false;
            this.fileConfirm(file);
        },
        fileConfirm(file) {
            if (this.child.attachment_list) {
                this.child.attachment_list.push(file);
            } else {
                this.child.attachment_list = [file];
            }
        },
        updateInfo(params = {}) {
            api.post('/ast-space/update-file-info', params, res => {
                if (res.code == 0) {
                
                }
            })
        },
        addParentHandle() {
            if (this.isExpired) {
                this.$message.warning('视频套餐已经到期，无法添加章节，请联系管理员续费');
                return;
            }
            this.$refs.catalogRef.addParentHandle();
        },
        saveParent(item, callback) {
            console.log('saveParent', item);
            
            let params = {
                course_id: this.params.id, // 课程id
                title: item.title // 标题
            }
            // 如果item.id包含parent，说明是新增
            if (item.id && !item.id.includes('parent')) {
                params.id = item.id;
            }
            // 新增或更新章节
            api.post('/ast-course-video/sync-chapter', params, res => {
                if (res.code == 0) {
                    // 调用回调函数
                    callback && callback(res.data.id);
                }
            })
        },
        // 添加小节
        addSubItem(item) {
            console.log('addSubItem', item);
            if (this.isExpired) {
                this.$message.warning('视频套餐已经到期，无法添加小节，请联系管理员续费');
                return;
            }
            if (item.title) {
                this.editItemParent = item;
                this.editItem = {
                    id: '',
                    title: '',
                    summary: '',
                    attachment_list: [],
                    homeworks: []
                };
                this.isEdit = false;
                this.showEditSubItem = true;
                console.log('addSubItem', item);
            }
        },
        // 编辑小节
        editSubItem(item, subItem) {
            if (this.isExpired) {
                this.$message.warning('视频套餐已经到期，无法编辑小节，请联系管理员续费');
                return;
            }
            this.editItemParent = item;
            this.editItem = subItem;
            this.isEdit = true;
            this.showEditSubItem = true;
        },
        saveSubItem() {
            console.log('saveSubItem', this.editItem);
            if (this.editItem.title) {
                let params = {
                    course_id: this.params.id, // 课程id
                    parent_id: this.editItemParent.id, // 章节id
                    title: this.editItem.title, // 标题
                    summary: this.editItem.summary, // 摘要
                    attachment_list: this.editItem.attachment_list, // 附件列表
                    homeworks: this.editItem.homeworks, // 作业列表
                    qa_ids: this.editItem.qa_ids, // 问卷列表
                }
                
                if (this.editItem.file_id) { // 视频id
                    params.file_id = this.editItem.file_id;
                    
                }
                if (this.editItem.id) {
                    params.id = this.editItem.id;
                }
                
                api.post('/ast-course-video/sync-section', params, res => {
                    if (res.code == 0) {
                        this.editItem.id = res.data.id;
                        this.$refs.catalogRef.saveSubItem(this.isEdit, this.editItemParent, this.editItem, () => {
                            this.showEditSubItem = false;
                        });
                        this.$message.success('保存成功');
                        console.log('保存成功');
                    } else {
                        console.log('保存失败');
                        this.$message.error('保存失败');
                    }
                })
                
            } else {
                this.$message.error('请输入小节标题');
                
                // if (!this.editItem.title) {
                //     return this.$message.error('请输入小节标题');
                // }
                // if (!this.editItem.file) {
                //     return this.$message.error('请选择或上传视频');
                // }
            }
        },
        addHomework() {
            this.editItem.homeworks.push({title: ''})
        },
        delHomework(idx) {
            this.editItem.homeworks.splice(idx, 1);
        },
        delChildHandle(i, k) {
            let _this = this;
            this.$confirm({
                title: "确定要删除这个小节吗？",
                onOk: () => {
                    _this.catalogs[i].children.splice(k, 1);
                    if (_this.catalogs[i].children.length == 0) {
                        _this.catalogs.splice(i, 1);
                    }
                }
            })
        },
        getDetail(id) {
            api.get('/course/detail', {id}, (res) => {
                
                if (res.code == 0) {
                    
                    let item = res.data;
                    
                    delete item.content_img;
                    delete item.created_at;
                    delete item.updated_at;
                    delete item.poster;
                    delete item.poster_frame;
                    delete item.finish;
                    delete item.shares_count;
                    if (item.type == 'video') {
                        this.list = item.videos;
                    }
                    
                    if (!item.give_permissions) item.give_permissions = []
                    if (!item.give_appointments) item.give_appointments = []
                    
                    this.params = item;
                    this.isOpenPlaySwitch = item.play_mode == 'order'
                }
            })
        },
        getPermissionsAndLevels() {
            api.get('/ast-app/permissions-and-levels', (res) => {
                
                this.memberLevels = res.data.levels;
                this.memberPermissions = res.data.permissions;
                
            })
        },
        submit() {
            if (this.params.type == 'video' && this.params.id) {
                let list = this.$refs.catalogRef.catalogs;
                console.log('catalogs', list);
                this.params.videos = list;
                this.submitFun();
            } else {
                this.submitFun();
            }
            console.log('params', this.params);
        },
        submitFun() {
            api.post('/course/sync', this.params, (res) => {
                if (res.code == 0) {
                    this.$message.success('已成功保存，手机端须重新进入小程序方可生效')
                    this.$router.replace({
                        path: '/ast/serve/cla'
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.add-modal-box {
    
    .add-form-row {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        
        .child-label {
            font-size: 14px;
            margin-right: 23px;
            
            .text {
                color: #333;
            }
            
            .tips {
                color: #999;
            }
        }
        
        .label {
            width: 56px;
            color: #333333;
            font-size: 14px;
            margin-right: 16px;
            text-align: center;
        }
        
        .input-container {
            flex: 1;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            padding: 0 16px;
            box-sizing: border-box;
            
            .textarea {
                width: 100%;
                min-height: 100px;
            }
        }
        
        .video-container {
            width: 136px;
            height: 102px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            
            .no-video {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: rgba(0, 0, 0, 0.25);
                font-size: 14px;
            }
            
            .video {
                width: 136px;
                height: 102px;
                position: relative;
                cursor: pointer;
                
                .mask {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    
                    .name {
                        width: 100%;
                        text-align: center;
                        color: #FFFFFF;
                        font-size: 12px;
                        position: absolute;
                        bottom: 8px;
                        left: 0;
                    }
                    
                    .size {
                        height: 14px;
                        line-height: 14px;
                        background: #FFFFFF;
                        border-radius: 2px;
                        padding: 0 4px;
                        color: #000000;
                        font-size: 10px;
                        position: absolute;
                        top: 4px;
                        left: 4px;
                    }
                    
                    .icon {
                        width: 20px;
                        height: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        top: 0;
                        right: 0;
                        
                        img {
                            width: 12px;
                            height: 12px;
                        }
                    }
                    
                }
                
                .thumb {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
        
        .video-btn-row {
            display: flex;
            align-items: center;
            
            .video-btn {
                width: 100px;
                height: 28px;
                background: #F7F7F7;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;
                
                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
                
                span {
                    color: #333333;
                    font-size: 14px;
                }
            }
        }
    }
    
    .home-work-container {
        align-items: flex-start;
        
        .home-work-list {
            flex: 1;
            
            .home-work-btn-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                
                .add {
                    width: 100px;
                    height: 28px;
                    background: #F7F7F7;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 16px;
                    cursor: pointer;
                    
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 4px;
                    }
                    
                    span {
                        color: #333;
                        font-size: 12px;
                    }
                }
            }
            
            .home-work {
                width: 100%;
                height: 40px;
                background: #FFFFFF;
                border: 1px solid #EEEEEE;
                display: flex;
                align-items: center;
                padding-left: 16px;
                margin-bottom: 10px;
                
                input {
                    flex: 1;
                }
                
                .del-box {
                    cursor: pointer;
                    width: 48px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
            }
        }
    }
}

.btn-box {
    display: flex;
    margin-top: 40px;
    margin-bottom: 40px;
    
    .btn {
        margin-right: 16px;
    }
    
    .btn-white {
        color: #333333;
        border: 1px solid #333;
        background: #FFFFFF;
    }
}

.container {
    width: 920px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    margin-top: 32px;
    
    .head {
        width: 100%;
        height: 56px;
        line-height: 56px;
        border-bottom: 1px solid #EEEEEE;
        padding: 0 24px;
        position: relative;
        
        .label {
            color: #000;
            font-size: 16px;
        }
        
        .line {
            width: 2px;
            height: 14px;
            background: #333333;
            position: absolute;
            left: 0;
            top: 21px;
        }
    }
    
    .catalog-box {
        width: 100%;
        
        .add-parent {
            width: 100%;
            height: 102px;
            background: #F7F7F7;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #333333;
            font-size: 14px;
            
            img {
                width: 30px;
                height: 30px;
                margin-top: 4px;
            }
        }
    }
    
    .content-box {
        width: 100%;
        padding: 24px;
        
        .contents {
            .content-item {
                .parent {
                    display: flex;
                    margin-bottom: 24px;
                }
                
                .child {
                    margin-bottom: 24px;
                    
                    .child-summary {
                        padding-left: 74px;
                        
                        textarea {
                            width: 728px;
                            min-height: 100px;
                            padding: 16px;
                        }
                    }
                    
                    .child-video {
                        display: flex;
                        align-items: center;
                    }
                    
                    .child-info {
                        .info-right {
                            width: 728px;
                        }
                    }
                    
                    .home-work {
                        .info-right {
                            width: 728px;
                        }
                    }
                    
                    .add-input-box {
                        margin-bottom: 16px;
                        
                        .input {
                            margin-bottom: 12px;
                            position: relative;
                            
                            .del-box {
                                width: 48px;
                                height: 40px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                                position: absolute;
                                right: 0;
                                top: 0;
                                
                                img {
                                    width: 16px;
                                    height: 16px;
                                }
                            }
                        }
                        
                        .add {
                            width: 100px;
                            height: 28px;
                            background: #F7F7F7;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-top: 16px;
                            cursor: pointer;
                            
                            img {
                                width: 16px;
                                height: 16px;
                                margin-right: 4px;
                            }
                            
                            span {
                                color: #333;
                                font-size: 12px;
                            }
                        }
                    }
                    
                    .child-label {
                        font-size: 14px;
                        margin-right: 23px;
                        
                        .text {
                            color: #333;
                            
                        }
                        
                        .tips {
                            color: #999;
                        }
                    }
                    
                    .video-box {
                        .video {
                            width: 136px;
                            height: 102px;
                            border: 1px solid #EEEEEE;
                            margin-bottom: 16px;
                            position: relative;
                            cursor: pointer;
                            
                            .mask {
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                top: 0;
                                left: 0;
                                
                                .name {
                                    width: 100%;
                                    text-align: center;
                                    color: #FFFFFF;
                                    font-size: 12px;
                                    position: absolute;
                                    bottom: 8px;
                                    left: 0;
                                }
                                
                                .size {
                                    height: 14px;
                                    line-height: 14px;
                                    background: #FFFFFF;
                                    border-radius: 2px;
                                    padding: 0 4px;
                                    color: #000000;
                                    font-size: 10px;
                                    position: absolute;
                                    top: 4px;
                                    left: 4px;
                                }
                                
                                .icon {
                                    width: 20px;
                                    height: 20px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    
                                    img {
                                        width: 12px;
                                        height: 12px;
                                    }
                                }
                                
                            }
                            
                            .thumb {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                        
                        .btn-row {
                            display: flex;
                            align-items: center;
                            // margin-top: 16px;
                            
                            .btn-item {
                                width: 100px;
                                height: 28px;
                                background: #F7F7F7;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin-right: 12px;
                                
                                img {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 4px;
                                }
                                
                                span {
                                    color: #333333;
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }
                
                .label {
                    color: #333333;
                    font-size: 14px;
                    margin-top: 10px;
                    margin-right: 16px;
                    
                    .red {
                        color: #FF2323;
                    }
                    
                    .white {
                        color: #FFFFFF;
                    }
                }
                
                .input {
                    width: 728px;
                    height: 40px;
                    background: #FFFFFF;
                    border: 1px solid #EEEEEE;
                    padding: 10px 16px;
                    display: flex;
                    align-items: center;
                    position: relative;
                    
                    .title {
                        width: 32px;
                        height: 32px;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                    
                    .util {
                        width: 176px;
                        height: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-left: 20px;
                        
                        .line {
                            width: 1px;
                            height: 20px;
                            background: #EEEEEE;
                        }
                        
                        .add {
                            color: #FBB03B;
                            font-size: 14px;
                        }
                        
                        .del {
                            color: #F5606D;
                            font-size: 14px;
                        }
                    }
                }
            }
        }
        
        .form-row {
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            
            .form-item {
                display: flex;
                align-items: center;
                margin-right: 32px;
                
                .form-label {
                    font-size: 14px;
                    margin-right: 23px;
                    
                    .label {
                        color: #333;
                        text-align: center;
                    }
                    
                    .tips {
                        color: #999;
                    }
                }
                
                .form {
                    width: 168px;
                    
                    .input {
                        width: 168px;
                        height: 40px;
                        background: #FFFFFF;
                        border: 1px solid #EEEEEE;
                        display: flex;
                        align-items: center;
                        position: relative;
                        
                        .scale-unit {
                            line-height: 40px;
                            position: absolute;
                            top: 0;
                            right: 16px;
                        }
                        
                        input {
                            width: 100%;
                            height: 100%;
                            padding: 0 16px;
                        }
                    }
                    
                    .at-select {
                        width: 100%;
                        
                        /deep/ .ant-select-selection--single {
                            height: 40px;
                            border-radius: 0;
                        }
                        
                        /deep/ .ant-select-selection__rendered {
                            line-height: 40px;
                        }
                    }
                    
                    .date-picker {
                        /deep/ .ant-input {
                            height: 40px;
                            border-radius: 0;
                        }
                        
                        /deep/ .ant-calendar-range-picker-separator {
                            line-height: 30px;
                        }
                    }
                }
            }
        }
        
        .row {
            display: flex;
            margin-bottom: 24px;
            
            .label {
                color: #333333;
                font-size: 14px;
                margin-top: 10px;
                margin-right: 16px;
                
                .red {
                    color: #FF2323;
                }
                
                .white {
                    color: #FFFFFF;
                }
            }
            
            .input-box {
                width: 728px;
                background: #FFFFFF;
                border: 1px solid #EEEEEE;
                padding: 10px 16px;
                display: flex;
                align-items: center;
                position: relative;
                
                .num {
                    color: rgba(0, 0, 0, 0.25);
                    font-size: 14px;
                    line-height: 20px;
                    position: absolute;
                    right: 16px;
                    bottom: 10px;
                }
                
                textarea {
                    line-height: 20px;
                }
            }
            
            .thumb-tips {
                font-size: 12px;
                font-weight: 400;
                color: #999999;
                line-height: 22px;
            }
        }
    }
}

input,
textarea {
    width: 100%;
    line-height: 20px;
    resize: none;
    border: none;
    outline: none;
    padding: 0;
    color: #333;
    font-size: 14px;
    box-shadow: none !important;
}


.video-play-btn {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4);
    background-image: url("/assets/icons/video-play-btn.png");
    background-size: auto;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}


.at-item-warning {
    font-weight: 400;
    font-size: 14px;
    color: #FBB03B;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    padding-left: 18px;
    background: url("/assets/icons/warning-cycle.png") no-repeat left top;
    background-size: 16px;
    background-position-y: 3px;
}

.save-sub-btn {
    position: absolute;
    right: 24px;
    bottom: 24px;
    width: 80px;
    height: 28px;
    text-align: center;
}

.empty-label {
    width: 64px !important;
}

.head-label, .play-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.play-label {
    .attr {
        margin-right: 16px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
    }
}

.expire-warning {
    margin-bottom: 16px;
}
</style>